export default __webpack_public_path__ + "static/media/prev-GNSS-Antenna-4.e3cf7ba9.png";